<template>
  <div class="customPage tutorial">
    <h2 class="customPageTitle">회원가입을 축하합니다 :)</h2>

    <v-container class="customPageContent text-center">
      <v-text-field
        maxlength="20"
        v-model="nickname"
        label="닉네임"
      ></v-text-field>
      <div class="tutorialText mb-10">
        <p class="tutorialTitle">위던이란?</p>
        'We Done'으로, 우리가 해냈다! 라는 뜻입니다.
        <br />
        서포터는 보상을 걸고, 챌린저는 보상을 받기 위해 미션을 수행하는, 둘이서 노력할 수 있는 노력형 챌린지 어플입니다 :)
        <br>
        <br /><br />
        노력하면서 얻는 보람을 어플을 통해 두 배로 느껴보세요!
        <br /><br />

        <p class="tutorialTitle">챌린지 시작하기</p>
        <v-btn 
          class="customButton" 
          @click="start"
        >챌린지 시작</v-btn>
      </div>

      <div style="margin-bottom: 40px; border-bottom: 1px dashed #ccc"></div>

      <p class="tutorialTitle mb-0">혹시 초대 코드를 받으셨나요?👇</p>
      <v-form>
        <v-text-field
          maxlength="20"
          v-model="code"
          placeholder="초대 코드를 입력하세요!"
          hide-details
        ></v-text-field>
        <v-btn 
          class="customButton gray mb-5" 
          @click="submitCode"
        >초대 코드 입력</v-btn>
      </v-form>
      <p class="tutorialText">
        초대된 카카오톡 대화에서 "함께하기"를 누르신 후, 챌린지 시작 버튼을 누르시면 빠르게 참여가 가능해요!
      </p>
    </v-container>
    <span v-if="alert" class="alert">
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </div>
</template>
<script>
// 튜토리얼
export default {
  name: "Tutorial",
  data() {
    return {
      nickname: undefined,
      code: undefined,
      alert: false,
      alertMessage: undefined,
    };
  },
  methods: {
    start() {
      if (!this.nickname) {
        this.alert = true;
        this.alertMessage = "닉네임을 입력해주세요.";
        return false;
      } else {
        // this.$store
        //   .dispatch("nickname", {
        //     nickname: this.nickname,
        //   })
        //   .catch((error) => {
        //     this.alert = true;
        //     this.alertMessage = "회원가입에 실패하였습니다. 다시 시도해주세요.";
        //     return false;
        //   })
        //   .then(() => {
        //     var code = window.localStorage.getItem("code");
        //     if (code) {
        //       this.$router.push("/invited?code=" + code);
        //     } else {
        //       this.$router.push("/start");
        //     }
        //   });
        this.$router.push("/start");
      }
    },
    submitCode() {
      if (!this.nickname) {
        this.alert = true;
        this.alertMessage = "닉네임을 입력해주세요.";
        return false;
      }else if (!this.code){
        this.alert = true;
        this.alertMessage = "초대 코드를 입력해주세요.";
        return false;
      }
      // this.$axios
      //   .post("/challenges/join", { code: this.code })
      //   .then((response) => {
      //     this.overlay = false;

      //     if (response.data === null) {
      //       this.alert = true;
      //       this.alertMessage = "초대 코드가 잘못됬어요. :(";
      //       return false;
      //     } else if (response.data === false) {
      //       this.alert = true;
      //       this.alertMessage = "자기자신을 초대할 수 없어요.";
      //       return false;
      //     } else {
      //       window.localStorage.setItem(
      //         "challengeInfo",
      //         JSON.stringify(response.data)
      //       );
      //       this.$store
      //         .dispatch("challenge", { body: response.data })
      //         .then(() => {
      //           window.localStorage.removeItem("code");
      //           this.$router.push("/home");
      //         });
      //     }
      //   });
      this.$router.push("/home");
    },
  },
  mounted() {
    this.nickname = this.$store.getters.nickname;
  },
};
</script>
<style lang="scss">
.tutorial {
  .tutorialTitle {
    color: #ffb5cc;
    font-size: 18px;
    font-weight: 700;
  }
  .tutorialText {
    font-size: 14px;
    word-break: keep-all;
  }
  .v-text-field {
    label,
    input {
      text-align: center;
    }
    input::placeholder{
      color: rgba(0, 0, 0, 0.6) !important;
      font-size: 16px;
    }
    .v-label {
      left: 50% !important;
      transform: translateX(-50%);
    }
    .v-label--active {
      left: 50% !important;
      transform: translateY(-18px) translateX(calc(-50% + 6px)) scale(0.75);
    }
  }
}
</style>
<style lang="scss" scoped>
.alert{
  bottom: 0;
}
</style>